<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Importer fra data fil
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group" v-show="dialogMode != 'importsuccess'">

										<div class="input-group">
											<label>
												Aftale
											</label>

											<select v-model="agreementID" ref="agreementid">
												<option v-if="agreements.length == 0" value="0">Ingen aftaler fundet</option>
												<option v-if="agreements.length > 1" value="0">Vælg aftale</option>
												<option v-for="(agreement, index) in agreements" :key="index" v-bind:value="agreement.id">
													{{ agreement.name }}
												</option>
											</select><span></span>
										</div>

										<div v-if="agreements.length == 0">
											Mindst én aftale skal oprettes før der kan importeres data.
										</div>

										<div v-if="agreements.length > 0 && agreementID == 0">
											Vælg venligst en aftale at importere til.
										</div>

										<div class="input-group" ref="uploadgroup" v-if="agreements.length > 0 && agreementID != 0">
											<label for="upload">
												Data fil
											</label>
											<input type="file" id="upload" ref="upload" v-on:change="handleFileChanged">
											<label for="upload" @click.self="handleFileChanged">Vælg fil</label>
										</div>

										<div class="input-group" v-show="choosenfile">
											<label>
												Valgt fil
											</label>
											<input type="text" ref="filename" readonly="readonly" />
										</div>
									</div>

									<div class="form-group" v-show="dialogMode != 'validate'">
										<div class="input-group import-result">
											<label ref="summarytitle">
												Validerings resultat
											</label>
											<div>
												<table>
													<tr>
														<th>Filformat:</th>
														<td ref="import_fileformat"></td>
													</tr>
													<tr>
														<th>Institutionsnavn:</th>
														<td ref="import_institutionname"></td>
													</tr>
													<tr>
														<th>Børn:</th>
														<td ref="import_childrencount"></td>
													</tr>
													<tr>
														<th>Ansatte:</th>
														<td ref="import_employeecount"></td>
													</tr>
													<tr>
														<th>Grupper:</th>
														<td ref="import_groupcount"></td>
													</tr>
													<tr v-show="importerror">
														<th colspan="2">Fejl:</th>
													</tr>
													<tr v-show="importerror">
														<td colspan="2" ref="import_error"></td>
													</tr>
													<tr v-if="dialogMode == 'importsuccess'">
														<th colspan="2">Status:</th>
													</tr>
													<tr v-if="dialogMode == 'importsuccess'">
														<td colspan="2" style="color: darkgreen;">&#10004; Fil importeret</td>
													</tr>
												</table>
											</div>
										</div>
									</div>
								</div>

								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="close" class="text" v-if="dialogMode != 'importsuccess'">
										Tilbage
									</button>
									<button type="button" ref="nextbutton" @click.prevent="uploadFile" disabled="disabled" v-if="dialogMode == 'validate' || dialogMode == 'validationfailed'">
										Valider fil
									</button>
									<button type="button" ref="nextbutton" @click.prevent="uploadFile" disabled="disabled" v-if="dialogMode == 'readyforimport'">
										Importer fil
									</button>
									<button type="button" ref="nextbutton" @click.prevent="close" v-if="dialogMode == 'importsuccess'">
										Luk
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { appFeedbackStateEnum } from "@/app/enums/common";
	import { importPersonsAndGroupsModeEnum } from "@/app/enums/common";

	export default {
		name: "PersonImport",
		data()
		{
			return {
				dialogMode: importPersonsAndGroupsModeEnum.VALIDATE,
				dialogTitle: "Importer fra data fil",
				customerID: 0,
				choosenfile: null,
				importerror: false,
				importerrortext: "",
				agreementID: 0,
				agreements: []
			}
		},
		async mounted()
		{
			this.setModalIsVisible()
			this.customerID = this.$route.params.customerid
			this.setAppAsBusyModal();

			try
			{
				// Get agreements
				var searchdata = { customerID: this.customerID, period: 0, status: 0 }
				var agreementsResult = await this.$store.dispatch(types.ACTION_GET_AGREEMENTS, searchdata);

				if (agreementsResult.status == 200)
				{
					this.agreements = agreementsResult.data

					if (this.agreements.length == 1)
					{
						this.agreementID = this.agreements[0].id
					}

					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("PersonsImport.loadData() getAgreements", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.")
					this.$router.push({ name: "PersonGroups", params: { customerid: this.customer.id } })
				}

				// Get customer
				var customerResult = await this.$store.dispatch(types.ACTION_GET_CUSTOMER, this.customerID);

				if (customerResult.status == 200)
				{
					this.customer = customerResult.data
					this.dialogTitle = "Importer fra data fil til " + this.customer.name
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("PersonsImport.loadData() getcustomer", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.");
					this.$router.push({ name: "PersonGroups", params: { customerid: this.customer.id } })
				}
			}
			catch (error)
			{
				this.setAppAsIdle()
				logError("PersonsImport.loadData()", error)
				this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
				this.$router.push({ name: "PersonGroups", params: { customerid: this.customer.id } })
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		methods:
		{
			getFileFormatName(fileformat)
			{
				switch (fileformat)
				{
					case 2:
						return "KMDEduca";
					case 3:
						return "SkoleIntra";
					case 4:
						return "UV-Data";
					case 5:
						return "Comit";
					case 6:
						return "CSV fil med email og mobilnummer";
					case 7:
						return "ImageMakers Xslx";
					default:
						return "Ukendt";
				}
			},
			handleFileChanged()
			{
				if (this.$refs.upload.files.length > 0)
				{
					this.dialogMode = importPersonsAndGroupsModeEnum.VALIDATE
					this.choosenfile = this.$refs.upload.files[0];
					this.$refs.filename.value = this.choosenfile.name
					this.$refs.nextbutton.removeAttribute("disabled")
				}
			},
			close()
			{
				if (this.agreementID && this.agreementID != undefined && this.agreementID != 0)
				{
					this.$router.push({ name: "PersonGroups", params: { customerid: this.customer.id, agreementid: this.agreementID } })
				}
				else
				{
					this.$router.push({ name: "Agreements", params: { customerid: this.customer.id } })
				}
			},
			setErrorMessages()
			{
				var errorMessages = this.importerrortext.split("\n");

				if (!this.importerrortext)
				{
					this.$refs.import_error.innerHTML = ""
					return
				}

				var errorHtml = "<ul class=\"errors\">";

				for (let message of errorMessages)
				{
					if (message)
					{
						errorHtml += "<li>" + message.replace("\n", "") + "</li>"
					}
				}

				errorHtml += "</ul>"
				this.$refs.import_error.innerHTML = errorHtml
			},
			async uploadFile()
			{
				try
				{
					var valid = true
					var validationFocus = false

					if (this.choosenfile == null)
					{
						this.$refs.uploadgroup.setAttribute("data-validation", "Vælg venligst en fil at uploade")
						this.$refs.upload.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.uploadgroup.removeAttribute("data-validation")
					}

					if (!valid)
					{
						return;
					}

					this.setAppAsBusyModal()

					let formData = new FormData();
					formData.append("file", this.choosenfile);

					let data =
					{
						formdata: formData,
						customerid: this.customerID,
						agreementid: this.agreementID
					}

					if (this.dialogMode == importPersonsAndGroupsModeEnum.VALIDATE || this.dialogMode == importPersonsAndGroupsModeEnum.VALIDATIONFAILED)
					{
						var result = await this.$store.dispatch(types.ACTION_IMPORT_PERSONS_AND_GROUPS_VALIDATE_FILE, data)
						this.importerrortext = ""
						this.importerror = false
						this.$refs.summarytitle.innerText = "Validerings resultat"

						if (result.status == 200)
						{
							this.$refs.import_fileformat.innerText = this.getFileFormatName(result.data.fileformat)
							this.$refs.import_institutionname.innerText = result.data.customername;
							this.$refs.import_childrencount.innerText = result.data.childdatavalidcount;
							this.$refs.import_employeecount.innerText = result.data.employeedatavalidcount;
							this.$refs.import_groupcount.innerText = result.data.groupdatavalidcount;

							if (result.data.childdatainvalidcount > 0)
							{
								this.$refs.import_childrencount.innerText += " (" + result.data.childdatainvalidcount + " fejlet)";
							}

							if (result.data.employeedatainvalidcount > 0)
							{
								this.$refs.import_employeecount.innerText += " (" + result.data.employeedatainvalidcount + " fejlet)";
							}

							if (result.data.groupdatainvalidcount > 0)
							{
								this.$refs.import_groupcount.innerText += " (" + result.data.groupdatainvalidcount + " fejlet)";
							}

							if (result.data.unknowndatainvalidcount > 0)
							{
								this.importerrortext = "Der blev fundet " + result.data.unknowndatainvalidcount + " linjer i filen der ikke kunne importeres, eller som importeres med fejl:";
								this.importerrortext += result.data.errordata
								this.importerror = true
								this.setErrorMessages()
							}

							this.dialogMode = importPersonsAndGroupsModeEnum.READYFORIMPORT
							this.setAppAsIdle()
						}
						else if (result.status == 400)
						{
							if (result.data.errormessage == "CustomerValidationException")
							{
								this.importerrortext = "Der opstod en ukendt fejl ved validering af institutionsdata.\n"
							}
							else if (result.data.errormessage == "CustomerDataInvalidElementCount")
							{
								this.importerrortext = "Institutions data format ikke korrekt: " + result.data.errordata + ".\n"
							}
							else if (result.data.errormessage == "CustomerDataUnknownData")
							{
								this.importerrortext = "Institution ikke fundet i teksten: &quot;" + result.data.errordata + "&quot;.\n"
							}
							else if (result.data.errormessage == "CustomerDataNotvalid")
							{
								this.importerrortext = "Institutions data format ikke korrekt: " + result.data.errordata + ".\n"
							}
							else if (result.data.errormessage == "FileIsEmpty")
							{
								this.importerrortext = "Den uploadede fil er tom, eller kan ikke læses.\n"
							}
							else
							{
								if (result.data.errormessage == "NoChildrenToImport")
								{
									if (result.data.childdatavalidcount == 0 && result.data.childdatainvalidcount > 0)
									{
										this.importerrortext += "Der blev ikke fundet nogen korrekt data, til at importere børn i filen.\n"
									}
									else
									{
										this.importerrortext += "Der blev ikke fundet nogen børn at importere i filen.\n"
									}
								}
								else if (result.data.errormessage == "NoEmployeesToImport")
								{
									if (result.data.employeedatavalidcount == 0 && result.data.employeedatainvalidcount > 0)
									{
										this.importerrortext += "Der blev ikke fundet nogen korrekt data, til at importere ansatte i filen.\n"
									}
									else
									{
										this.importerrortext += "Der blev ikke fundet nogen ansatte at importere i filen.\n"
									}
								}
								else if (result.data.errormessage == "NoGroupsToImport")
								{
									if (result.data.groupdatavalidcount == 0 && result.data.groupdatainvalidcount > 0)
									{
										this.importerrortext += "Der blev ikke fundet nogen korrekt data, til at importere grupper i filen.\n"
									}
									else
									{
										this.importerrortext += "Der blev ikke fundet nogen grupper at importere i filen.\n"
									}
								}
							}

							if (this.importerrortext == null)
							{
								this.importerrortext = "Der opstod en ukendt fejl under validering af filen."
							}

							this.setErrorMessages();
							this.importerror = true;
							this.dialogMode = importPersonsAndGroupsModeEnum.VALIDATIONFAILED
							this.setAppAsIdle();
							return;
						}
						else
						{
							this.setAppAsIdle()
							logError("PersonImport.uploadFile(" + this.dialogMode + ")", result.status)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
					else if (this.dialogMode == importPersonsAndGroupsModeEnum.READYFORIMPORT)
					{
						var result = await this.$store.dispatch(types.ACTION_IMPORT_PERSONS_AND_GROUPS_IMPORT_FILE, data)
						this.importerrortext = ""
						this.importerror = false
						this.$refs.summarytitle.innerText = "Import resultat"

						if (result.status == 200)
						{
							this.$refs.import_institutionname.innerText = result.data.customername;
							this.$refs.import_childrencount.innerText = result.data.childdatavalidcount;
							this.$refs.import_employeecount.innerText = result.data.employeedatavalidcount;
							this.$refs.import_groupcount.innerText = result.data.groupdatavalidcount;

							if (result.data.childdatainvalidcount > 0)
							{
								this.$refs.import_childrencount.innerText += " (" + result.data.childdatainvalidcount + " fejlet)";
							}

							if (result.data.employeedatainvalidcount > 0)
							{
								this.$refs.import_employeecount.innerText += " (" + result.data.employeedatainvalidcount + " fejlet)";
							}

							if (result.data.groupdatainvalidcount > 0)
							{
								this.$refs.import_groupcount.innerText += " (" + result.data.groupdatainvalidcount + " fejlet)";
							}

							// Update local storage
							let data = { customerid: this.customerID, agreementid: this.agreementID }
							await this.$store.dispatch(types.ACTION_GET_PERSONGROUPS, data)
								.catch(error =>
								{
									logError("PersonImport.PersonGroupsList.loadData()", error)
								});

							await this.$store.dispatch(types.ACTION_GET_PERSONS, data)
								.catch(error =>
								{
									logError("PersonImport.PersonsList.loadData()", error)
								});

							this.setErrorMessages()
							this.dialogMode = importPersonsAndGroupsModeEnum.IMPORTSUCCESS
							this.setAppAsIdle();
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
						}
						else if (result.status == 400)
						{
							if (result.data.errormessage == "ImportException")
							{
								this.importerrortext = "Der opstod en ukendt fejl ved import af data. Tjek filen for fejl, og prøv igen.\n"
							}

							this.setErrorMessages();
							this.importerror = true;
							this.dialogMode = importPersonsAndGroupsModeEnum.IMPORTFAILED
							this.setAppAsIdle();
							return;
						}
						else
						{
							this.setAppAsIdle()
							logError("PersonImport.uploadFile(" + this.dialogMode + ")", result.status)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
				}
				catch (ex)
				{
					this.showErrorAlert(ex)
					this.setAppAsIdle()
				}
			}
		}
	};
</script>